import Common from '../common'
var Js = Common('order')
export default {
	name: 'order',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [
				{
					key: 'order_no',
					label: '订单NO',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width: 150,
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入订单NO',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.order_no = val;
							} else {
								delete self.searchItem.order_no;
							};

						},
					},
				},
				{
					key: 'price',
					label: '报名金额',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				
				{
					key: "pay_status",
					label: '支付状态',
					application: ['编辑'],
					type: 'select',
					listType: 'normal',
					formatter: function(val, tests) {
						if (val.pay_status == -1) {
							return '退款'
						} else if (val.pay_status === 0) {
							return '否'
						} else if (val.pay_status === 1) {
							return '是'
						}
					},
					componentName: 'sls-select',
					optionsName: 'payOptions',
					filter_multiple: false,
					listType: 'normal',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					placeholder: '请选择是否支付',
					width: 80,
					header_search: {
						componentName: 'sls-select',
						defaultValue: '',
						optionsName: 'payOptions',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请选择是否支付',
						changeFunc: function(val, self) {
							if (val || val === 0) {
								self.searchItem.pay_status = val;
							} else {
								delete self.searchItem.pay_status;
							};

						},
					}
				},
				{
					key: 'title',
					label: '报名活动',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'company_name',
					label: '公司名',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'name',
					label: '姓名',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'gender',
					label: '性别',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'birth',
					label: '生日',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'idCard',
					label: '身份证号',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'group',
					label: '竞赛组别',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'weight',
					label: '体重',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'bookCode',
					label: '已有证书编号',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'size',
					label: '衣服尺码',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'experience',
					label: '经验',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: "status",
					label: '状态',
					application: [],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						defaultValue: '',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};

						},
					},
					width: 200,
				},
				{
					key: 'mainImg',
					label: '照片',
					customSlot: 'mainImg',
					application: ['添加','编辑'],
					componentName: 'upload',
					listType: 'normal',
					limit: 10,
					dialogStyle: 'width:90%',
					width: 200
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],

			// 按钮配置
			btn_info: [


				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_orderUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
									user_type: 0,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_orderUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
									user_type: 0,
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'normal',
					position: 'header',
					func: {
						func: function(self) {
							self.excelOutput(self);
						},
					},
					text: function(data) {
						return '导出'
					},
					funcType: 'func',
				},
			],

			searchItem: {
				pay_status:1,
				level:0
			},

			startSearchItem: {
				pay_status:1,
				level:0
			},
			optionData: {
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
				payOptions: [{
					text: '未支付',
					value: 0
				}, {
					text: '已支付',
					value: 1
				}],
				transportOptions: [{
					text: '未发货',
					value: 0
				}, {
					text: '配送中',
					value: 1
				}, {
					text: '已收货',
					value: 2
				}],
				stepOptions: [{
					text: '正常下单',
					value: 0
				}, {
					text: '申请撤单',
					value: 1
				}, {
					text: '已撤单',
					value: 2
				}, {
					text: '完结',
					value: 3
				}],
				behaviorOptions: [{
					text: '采购',
					value: 1
				}, {
					text: '仓储',
					value: 2
				}],
				labelOptions: [],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			}

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		self.table_arguments.expand = true;
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
			this.initLabel();
		},


		async excelOutput(self) {

			if (self.btnName == '导出') {
				const postData = {};
				postData.token = self.$store.getters.getToken;
				if (self.searchItem) {
					postData.searchItem = self.$$cloneForm(self.searchItem)
					postData.searchItem.level = 2
				};
				postData.excelOutput = {
					expTitle: 'test',
					expCellName: [{
							title: '订单编号',
							key: ['order_no'],
							type: 'string',
						},
						{
							title: '订单金额',
							key: ['price'],
							type: 'string',
						},
						{
							title: '支付状态(1：已支付 0：未支付)',
							key: ['pay_status'],
							type: 'string',
						},
						{
							title: '购买商品',
							key: ['child', 0, 'title'],
							type: 'string',
						},
						{
							title: '地区',
							key: ['snap_address', 'city'],
							type: 'string',
						},
						{
							title: '详细地址',
							key: ['snap_address', 'detail'],
							type: 'string',
						},
						{
							title: '收货人',
							key: ['snap_address', 'name'],
							type: 'string',
						},
						{
							title: '联系电话',
							key: ['snap_address', 'phone'],
							type: 'string',
						},
					],
					fileName: 'test'
				};

				window.open('http://42.193.100.244/155/public/index.php/api/v1/Common/Order/get?token=' +
					postData.token +
					'&searchItem=' +
					JSON.stringify(postData.searchItem) +
					'&excelOutput=' +
					JSON.stringify(postData.excelOutput))
			}

		},

		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.table_arguments.loading = true;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				User: {
					tableName: 'User',
					middleKey: 'user_no',
					key: 'user_no',
					condition: '=',
					searchItem: {
						status: 1
					},
					info: ['nickname'],
				},
			};

			var res = await self.$$api_orderGet({
				data: postData
			});
			self.mainData = res.info.data;
			for (var i = 0; i < self.mainData.length; i++) {
				self.mainData[i].allCount = 0;
				for (var j = 0; j < self.mainData[i].child.length; j++) {
					self.mainData[i].allCount += self.mainData[i].child[j].count
				}
			};
			self.paginate.count = res.info.total;
			self.table_arguments.loading = false;

		},

		/**
		 * 列表主函数
		 */
		async initLabel() {

			const self = this;

			const postData = {};
			postData.token = self.$store.getters.getToken;
			postData.searchItem = {
				id: ["not in", [12, 14, 15]],
				thirdapp_id: 2,
				type: 2
			};
			var res = await self.$$api_labelGet({
				data: postData
			});
			self.optionData.labelOptions = res.info.data;


		},

		async initProductData(postData) {

			const self = this;
			postData.token = self.$store.getters.getToken;
			var res = await self.$$api_productGet({
				data: postData
			});

			if (res.info.data.length > 0) {
				for (var i = 0; i < res.info.data.length; i++) {
					res.info.data[i]['value'] = res.info.data[i]['title'];
					res.info.data[i]['product_str'] = res.info.data[i]['id'];
				};
				return res.info.data;
			} else {
				return [{
					"value": "无",
					"product_str": ""
				}];
			};

		},


	},


}



// WEBPACK FOOTER //
// ./src/views/order/order.js